import i18n from 'services/base/i18n';

export default {
  // The title for this page
  title: () => i18n.pgettext('Pages|List VPN Clients', 'VPN SERVER'),

  // The label for the vpn server settings
  serverHeader: () => i18n.pgettext('Pages|List VPN Clients', 'SERVER'),

  // Label for whether the vpn server should be turned on
  serverEnabled: () => i18n.pgettext('Pages|List VPN Clients', 'Enabled'),

  // The label at the start of the list
  listHeader: () => i18n.pgettext('Pages|List VPN Clients', 'CLIENTS'),

  // Label for when the VPN client access token has not yet been claimed
  statusUnclaimed: () => i18n.pgettext('Pages|VPN Client', 'Unclaimed'),

  // Label for when the VPN client access token has been disabled
  statusDisabled: () => i18n.pgettext('Pages|VPN Client', 'Disabled'),

  // Label for when the VPN client is online
  statusOnline: () => i18n.pgettext('Pages|VPN Client', 'Online'),

  // Label for when the VPN client is ooffline
  statusOffline: () => i18n.pgettext('Pages|VPN Client', 'Offline'),
};
